export default __webpack_public_path__ + "static/media/price-title-line.aeeff26a.svg";